import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .menu-header {
    display: none;
  }

  #player-nav-menu {
    position: static;
    display: flex;
    align-items: stretch;
    justify-content: flex-end;
    padding: 0;
    margin: 0;
    background: transparent none;
    border-bottom: none;
    background: none transparent;
    box-shadow: none;
    list-style: none;
    gap: 16px;
  }

  .menu-body {
    display: flex;
    align-items: center;
    height: 100%;
  }

  li.menu-item--upgrade-to-stv-player,
  li.menu-item--subscribe-to-stv-player {
    display: none;
  }

.live-card{
  gap: 8px;
}

  .menu-item a {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.11px;
    display: flex;
    align-items: center;
    color: ${colors.primaryText};
    padding: 0 12px;
    border-radius: 8px;
    height: 100%;
  }

  li.menu-item {
    height: 35px;
  }

  .menu-item.active a {
    background: ${colors.primaryText};
    color: ${colors.textInput};
    font-weight: 600;
  }

  .menu-item.active.menu-item--premier-sports a {
    background: yellow;
    color: black;
  }
 .live-card.active{
  background: ${colors.ctvBg};
 }
  .menu-item:hover:not(.active) a,
  .menu-item:focus:not(.active) a {
    background: ${colors.ctvBg};
  }

  .menu-item.menu-item--premier-sports:hover a,
  .menu-item.menu-item--premier-sports:focus a {
    background: yellow !important;
    color: black;
  }


  @media (max-width: 1299px) {
    .PlayerMenu {
      background: rgba(21, 21, 21, 0.75);
      backdrop-filter: blur(10px);
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 1;
      overflow: scroll;
      padding-bottom: 48px;
      padding-top: 7px;
      overflow: hidden;
      display:none;
    }

    .PlayerMenu.active {
      display: block;
    }

    .menu-header {
      display: flex;
      align-items: center;
      padding-right: 9px;
    }

    .menu-body {
      align-items: flex-start;
    }

    #player-nav-menu {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      line-height: 30px;
      display: block;
    }

    li.menu-item {
      // padding: 6px 12px;
      text-align: center;
      width: 270px;
      border-radius: 8px;
      margin-bottom: 10px;
      justify-content: center;
    }

    li.menu-item a {
      display: flex;
      justify-content: center;
    }

    li.menu-item.active {
      background: ${colors.primaryText};
    }

    li.menu-item.active a {
      color: ${colors.textInput};
    }

    li.menu-item--upgrade-to-stv-player,
    li.menu-item--subscribe-to-stv-player {
      display: flex;
    }

    .menu-body {
      padding-top: 48px;
      display: flex;
      justify-content: center;
    }

    .close-icon-wrapper {
      margin-left: auto;
      width: 43px;
      height: 43px;
    }

    button#close-button.close-icon {
      cursor: pointer;
      background: transparent;
      border: none;
      padding: none;
    }
  }

`
